import {Component, Input, OnInit} from '@angular/core';
import * as moment from 'moment';
import {MessageService} from "primeng/components/common/messageservice";
import {PagerService} from "../../../../core/pagination/pager.service";
import {DetailPromotionRequest} from "./detail-promotion-request";
import {PromocionesService} from "../../../../core/promociones/promociones.service";

declare var $: any;

@Component({
    selector: 'app-detail-table',
    templateUrl: './detail-table.component.html',
    styleUrls: ['./detail-table.component.scss']
})
export class DetailTableComponent implements OnInit {
    @Input() promotionKey: string;
    @Input() status: string;
    @Input() promotionType: string;

    loading = true;
    loadingRequest = false;
    maxDateValue = moment().subtract(1, 'days').toDate();
    messageModal = '';
    errorMessageModal = '';
    error = false;
    errorMessage = "";
    currentPage = 0;
    pages = [0, 1, 2, 3, 4];

    isFirstPage = true;
    isLastPage = true;
    lastPage;
    pager = {
        totalItems: 0,
        currentPage: 0,
        pageSize: 0,
        totalPages: 0,
        startPage: 0,
        endPage: 0,
        startIndex: 0,
        endIndex: 0,
        pages: 0
    };
    promotionDetails = [];

    conciliaiconDate = this.maxDateValue;

    private username = '';

    constructor(private promocionesService: PromocionesService,
                private pagerService: PagerService,
                private messageService: MessageService) {
    }

    ngOnInit() {
        console.log("ConciliacionTableComponent#conciliaiconDate", this.getconciliacionDate());
        this.requestData(0, 10);
        this.setMessage();
    }

    setMessage() {
        if (this.promotionType === 'quantum') {
            this.messageModal = 'Se ha enviado correo a los usuarios seleccionados';
            this.errorMessageModal = 'No se pudo enviar el correo';
        }

        if (this.promotionType === 'saldosGanalottodo') {
            this.messageModal = 'Se ha enviado la recompensa a los usuarios seleccionados';
            this.errorMessageModal = 'No se pudo enviar la recompensa';
        }
    }

    private getconciliacionDate() {
        return moment(this.conciliaiconDate).format("YYYY-MM-DD");
    }

    selecPage(page: number) {
        this.loading = true;
        this.requestData(page - 1, 10);
    }

    nextPage() {
        this.loading = true;
        this.requestData(this.currentPage + 1, 10);
    }

    goToFirstPage() {
        this.loading = true;
        this.requestData(0, 10);
    }

    private requestData(page, pageSize) {
        this.error = false;
        const user = this.username.trim().length > 0 ? this.username : undefined;
        const detailPromotionRequest = new DetailPromotionRequest(this.promotionKey, this.status, page, pageSize, user);
        this.promocionesService.getDetailPromotion(detailPromotionRequest).finally(() => {
            this.loading = false;
        }).subscribe((response) => {
            this.promotionDetails = response.content;
            this.currentPage = response.number;
            this.isFirstPage = response.first;
            this.isLastPage = response.last;
            this.lastPage = response.totalPages;
            this.pager = this.pagerService.getPager(response.totalElements, response.number, response.size);
        }, (err) => {
            this.error = true;
            this.errorMessage = err;
            console.log("ConciliacionTableComponent#ngOnInit", err);
        });
    }

    prevPage() {
        this.loading = true;
        this.requestData(this.currentPage - 1, 10);
    }

    goToLastPage() {
        this.loading = true;
        this.requestData(this.lastPage - 1, 10);
    }

    selectedDate() {
        this.requestData(0, 10);
    }

    searchUser(value: string) {
        this.loading = true;
        console.log("DetailTableComponent#searchUser:value");
        console.log(value);
        this.username = value;
        this.requestData(0, 10);
    }

    resendEmailPromotion() {
        const selectedUserNames = $(".promo-detail input:checked");
        console.log("resendEmailPromotion");
        console.log(selectedUserNames.length);
        if (selectedUserNames.length === 0) {
            this.messageService.add({
                severity: 'info',
                summary: '',
                detail: 'Debe seleccionar al menos una cuenta'
            });
        } else {
            if (this.status === "ERROR") {
                this.retryPromotion(selectedUserNames);
            } else {
                this.resendEmail(selectedUserNames);
            }
        }
    }

    private resendEmail(selectedPromotionIds) {
        const promotionIds = [];

        selectedPromotionIds.map((indx, el) => {
            promotionIds.push($(el).val());
        });
        this.loadingRequest = true;
        this.promocionesService.resendEmailPromotion(promotionIds).subscribe(() => {
            this.messageService.add({
                severity: 'success',
                summary: '',
                detail: this.messageModal
            });
            this.loadingRequest = false;
        }, error => {
            this.loadingRequest = false;
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: this.errorMessageModal
            });
        });
    }

    private retryPromotion(selectedPromotionIds: any) {
        const promotionIds = [];

        selectedPromotionIds.map((indx, el) => {
            promotionIds.push($(el).val());
        });
        this.loadingRequest = true;
        this.promocionesService.retryPromotion(promotionIds).subscribe((response) => {
            console.log(response);
            this.loadingRequest = false;
            if (response && response.length > 0) {
                response.forEach((user: string) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: user,
                        detail: this.errorMessageModal
                    });
                });
            } else {
                this.messageService.add({
                    severity: 'success',
                    summary: '',
                    detail: this.messageModal
                });
            }
        }, error => {
            this.loadingRequest = false;
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: this.errorMessageModal
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/detail-promotion/detail-table.component.ts